import {
  LOGIN_WITH_TOKEN_KEY,
  LOGIN_WITH_TOKEN_KEY_SUCCESS,
  LOGIN_WITH_TOKEN_KEY_FAIL,
  REGISTER_GUEST_TO_EVENT,
  REGISTER_GUEST_TO_EVENT_SUCCESS,
  REGISTER_GUEST_TO_EVENT_FAIL,
} from "./actionType";

const initialState = {
  loginWithTokenKeyLoading: true,
  loginWithTokenKeyData: [],
  loginWithTokenKeyError: null,

  registerGuestToEventLoading: false,
  registerGuestToEventData: [],
  registerGuestToEventError: null,
};

const EventReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_WITH_TOKEN_KEY:
      return {
        ...state,
        loginWithTokenKeyLoading: true,
      };
    case LOGIN_WITH_TOKEN_KEY_SUCCESS:
      return {
        ...state,
        loginWithTokenKeyLoading: false,
        loginWithTokenKeyData: action.payload,
      };
    case LOGIN_WITH_TOKEN_KEY_FAIL:
      return {
        ...state,
        loginWithTokenKeyLoading: false,
        loginWithTokenKeyError: action.payload,
      };
    case REGISTER_GUEST_TO_EVENT:
      return {
        ...state,
        registerGuestToEventLoading: true,
      };
    case REGISTER_GUEST_TO_EVENT_SUCCESS:
      return {
        ...state,
        registerGuestToEventLoading: false,
        registerGuestToEventData: action.payload,
      };
    case REGISTER_GUEST_TO_EVENT_FAIL:
      return {
        ...state,
        registerGuestToEventLoading: false,
        registerGuestToEventError: action.payload,
      };
    default:
      return state;
  }
};

export default EventReducer;
